// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-footer {
  display: flex;
  justify-content: space-between;
}
.modal-body{
  min-width: 720px;
}
#classTrainingWeeks{
  width: 190px;
  margin-right: 0px;
}

.table-list {
  border: 1px solid #c1bebe;
}

:host ::ng-deep .ag-body-viewport {
  /* border-left: 1px solid #dae2e8;
  border-right: 1px solid #dae2e8;
  border-bottom: 1px solid #dae2e8; */
}

:host ::ng-deep .training-weeks-input .p-inputnumber-input {
  font-size: 15px;
  height: 40px;
}

.update-table-btn {
  margin-left: 8px;
}

.flex-grow-1 .update-table-btn ::ng-deep .btn {
  margin-top: -5px;
}

:host ::ng-deep .ag-cell-wrapper > *:not(.ag-cell-value):not(.ag-group-value){

}

:host ::ng-deep .error-message {
  font-size: 13px;
}

:host ::ng-deep .info-message {
  font-size: 13px;
  color: #6c757d;
  font-style: italic;
}

:host ::ng-deep #name {
  width: 310px;
  display: block;
}

:host ::ng-deep #name:focus {
  border-color: #007cbe;
  outline: none;
}

:host ::ng-deep .wfm-textbox .valid-input:not(:focus),
:host ::ng-deep wfm-textbox .valid-input:not(:focus),
:host ::ng-deep .wfm-textbox .invalid-input:not(:focus),
:host ::ng-deep wfm-textbox .invalid-input:not(:focus) {
  border: solid 1px #ced4da !important;
}

wfm-plan-loading-overlay{
  top: 0;
  bottom: 0;
  position: absolute;
  left: -1px;
  right: 0;
  background: #00000014;
  z-index: 2;
}

::ng-deep .popover.delete-popup {
  max-width: 350px;
}
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
